import AnimatedTitle from './AnimatedTitle';

export default AnimatedTitle;
